<script lang="ts">
import { defineComponent, onBeforeUnmount } from 'vue'
import { useMessage } from 'naive-ui'
import { registerRequestErrorNotifier } from '../utils/requestFeedback'

export default defineComponent({
    name: 'RequestFeedback',
    setup() {
        const message = useMessage()
        const unregister = registerRequestErrorNotifier(text => message.error(text))
        onBeforeUnmount(unregister)
        return () => null
    }
})
</script>
